export const getTeamContactMessage = ({
  teamName,
  teamPageUrl,
  athleteName,
  email,
  phoneNumber,
  notes,
  createdAt,
}: {
  teamName: string;
  teamPageUrl: string;
  athleteName: string;
  email: string;
  phoneNumber: string | null;
  notes: string | null;
  createdAt: string;
}) => {
  return {
    unfurl_links: false,
    unfurl_media: false,
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `Team contact request - *<${teamPageUrl}|${teamName}>*`,
        },
      },
      {
        type: 'section',
        fields: [
          {
            type: 'mrkdwn',
            text: `*Athelete name:*\n${athleteName}`,
          },
          {
            type: 'mrkdwn',
            text: `*Email:*\n${email}`,
          },
          {
            type: 'mrkdwn',
            text: `*Phone number:*\n${phoneNumber}`,
          },
          {
            type: 'mrkdwn',
            text: `*Date submitted:*\n${createdAt}`,
          },
          {
            type: 'mrkdwn',
            text: `*Notes:*\n${notes}`,
          },
        ],
      },
    ],
  };
};
